import { trpc } from "@lango/api";

export const useUser = () => {
  const { data, isLoading, refetch } = trpc.getUser.useQuery();

  return {
    data,
    isLoading,
    refetch,
  };
};
